class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.navigationTabs = this.querySelector(".product-tabs__tabs");
    this.tabsContent = this.querySelectorAll(".product-tabs__content");

    if (!this.navigationTabs || !this.tabsContent.length) {
      return;
    }

    this.init();
  }

  init() {
    this.querySelectorAll(".product-tabs__tab").forEach((tab) => {
      tab.addEventListener("click", (event) => {
        const index = tab.getAttribute("data-index");
        this.activateTab(index);
      });
    });
  }

  activateTab(index) {
    this.querySelectorAll(".product-tabs__tab").forEach((tab) => tab.classList.remove("active"));
    this.querySelector(`.product-tabs__tab[data-index="${index}"]`).classList.add("active");

    this.tabsContent.forEach((tabContent) => {
      tabContent.classList.remove("active");
      if (tabContent.getAttribute("data-index") === index) {
        tabContent.classList.add("active");
      }
    });
  }
}

customElements.define("product-tabs", ProductTabs);
